export const FREE_STANDING_APPOINTMENT_CREATE = 'FREE_STANDING_APPOINTMENT_CREATE';
export const FREE_STANDING_APPOINTMENT_ERROR_CLEAR = 'FREE_STANDING_APPOINTMENT_ERROR_CLEAR';



// WEBPACK FOOTER //
// ./app/constants/freeStandingAppointmentTypes.js